

export default {
  name: 'Link',
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  computed: {
    type() {
      return 'router-link'
    }
  },
  methods: {
    linkProps(to) {
      return {
        to: to
      }
    }
  }
}
